import React, { useContext, useEffect, useState } from "react";
import { Box, SimpleGrid } from "@chakra-ui/react";
import HappyHourMenuTable from "views/admin/happyHourMenu/components/HappyHourMenuTable";
import { columnsData } from "views/admin/menuItem/variables/columnsData";
import { AppContext } from "contexts/AppContext";

export default function HappyHourMenu() {
  const options = [{ value: "1", label: "All Happy Hour Items" }];
  const [selectedOption, setSelectedOption] = useState("1");

  const { happyHourMenuItemData, fetchHappyHourMenuItemData } =
    useContext(AppContext);
  useEffect(() => {
    fetchHappyHourMenuItemData();
  }, []);

  const optionMappings = {
    1: { tableData: happyHourMenuItemData, title: "All Happy Hour Items" },
  };
  const selectedMapping = optionMappings[selectedOption];
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
        width={"100%"}
      >
        {selectedMapping && happyHourMenuItemData && (
          <HappyHourMenuTable
            columnsData={columnsData}
            tableData={selectedMapping.tableData}
            title={selectedMapping.title}
            setSelectedOption={setSelectedOption}
            options={options}
          />
        )}
      </SimpleGrid>
    </Box>
  );
}
